<template>
  <v-container class="margen">
    <vueHeadful
      :title="this.$i18n.t('Menu.Disenadores') + ' - TrArtist'"
      description="Productos de Diseñadores"
      :url="'https://trartist.com' + $route.fullPath"
    />
    <v-row>
      <v-col>
        <v-data-iterator
        :items="productosFiltrados"
        :items-per-page="itemsPorPagina"
        :search="buscar"
        hide-default-footer
        multi-sort
        :page.sync="pagina">
          <template v-slot:header>
              <v-row>
                <v-col cols="6" xs="6" md="3">
                  <v-text-field v-model="buscar" clearable flat solo-inverted persistent-hint prepend-inner-icon="fas fa-search" :label="$t('Busqueda.Buscar')" :hint="$t('Busqueda.Buscar')" />
                </v-col>
                <v-col cols="6" xs="6" md="3">
                  <v-autocomplete v-model="subcategoria" flat solo-inverted persistent-hint :items="subcategorias" item-text="titulo" item-value="id" :label="$t('Busqueda.Categoria')" :hint="$t('Busqueda.Categoria')"/>
                  <!-- <v-autocomplete v-model="subcategoriaEn" flat solo-inverted persistent-hint :items="subcategorias" item-text="titulo" item-value="id" :label="$t('Busqueda.Categoria')" :hint="$t('Busqueda.Categoria')" v-else /> -->
                </v-col>
                <v-col cols="6" xs="6" md="3">
                  <v-autocomplete v-model="precio" flat solo-inverted persistent-hint :items="precios" item-text="titulo" item-value="id" :label="$t('Busqueda.Precio')" :hint="$t('Busqueda.Precio')" />
                </v-col>
                <v-col cols="6" xs="6" md="3">
                  <v-autocomplete v-model="paisDeOrigen" flat solo-inverted persistent-hint :items="paisesOrigen" item-text="name" item-value="name" :label="$t('Busqueda.PaisDeOrigen')" :hint="$t('Busqueda.PaisDeOrigen')" />
                </v-col>
              </v-row>
          </template>
          <template v-slot:default="props" v-intersect="onIntersect">
            <v-container class="pa-0">
              <v-row class="px-0">
                <v-col cols="12" xs="12" sm="6" md="4" v-for="(i, index) in props.items" :key="i.uid">
                  <v-row>
                    <v-col cols="12" @click="verProducto(i.uid)">
                      <div style="background: black;">
                        <v-hover v-slot:default="{ hover }">
                          <v-img :id="hover ? 'imagen' : ''" :src="i.imagenPrincipal" width="100%" aspect-ratio="1"/>
                        </v-hover>
                      </div>
                    </v-col>
                    <v-col cols="9" class="py-0">
                      <v-row>
                        <v-col cols="12" class="pb-0">
                          <span style="font-size:15px;">{{ i.titulo.toUpperCase() }}</span>
                        </v-col>
                        <v-col cols="12" class="py-0">
                          <router-link :to="'/u/'+i.artista.nombreDeUsuario" target= '_blank'>
                          <span style="font-size:15px;">{{ i.artista.nombre }}</span>
                          </router-link>
                        </v-col>
                        <v-col cols="12" class="py-0">
                          <span style="font-size:15px;color:#bdbdbd;">{{ $t('Busqueda.Largo')}} {{ i.dimensiones.largo }}cm x {{ $t('Busqueda.Ancho')}} {{ i.dimensiones.ancho }}cm x {{ $t('Busqueda.Alto')}} {{ i.dimensiones.alto }}cm</span>
                        </v-col>
                        <div v-if="i.exponer" cols="12" class="pb-0 pt-4 pl-3">
                          <span style="font-size:15px;" class="font-weight-bold">{{ $t('Formularios.Exhibicion').toUpperCase() }}</span>
                        </div>
                        <div v-else>
                          <v-col cols="12" class="pb-0 pt-4" v-if="i.fisico">
                            <span v-if="i.cantidadFisico < 1" style="font-size:15px;" class="font-weight-bold">{{ $t('Busqueda.Agotado').toUpperCase() }}</span>
                            <span v-else-if="getMoneda === 'COP'" style="font-size:15px;" class="font-weight-bold">${{ i.precioPago ? Number(i.precioPago).toLocaleString() : 0 }}</span>
                            <span v-else style="font-size:15px;" class="font-weight-bold">${{ i.precioPago ? Math.round(Number(i.precioPago/getDolar)).toLocaleString() : 0 }}</span>
                          </v-col>
                          <v-col cols="12" class="pb-0 pt-4" v-if="i.digital">
                            <span v-if="!i.ilimitado && i.cantidadDigital < 1" style="font-size:15px;" class="font-weight-bold">{{ $t('Busqueda.Agotado').toUpperCase() }}</span>
                            <span v-else-if="getMoneda === 'COP'" style="font-size:15px;" class="font-weight-bold">${{ i.precioPagoDig ? Number(i.precioPagoDig).toLocaleString() : 0 }}</span>
                            <span v-else style="font-size:15px;" class="font-weight-bold">${{ i.precioPagoDig ? Math.round(Number(i.precioPagoDig/getDolar)).toLocaleString() : 0 }}</span>
                          </v-col>
                        </div>
                      </v-row>
                    </v-col>
                    <v-col cols="3" class="pa-0">
                      <v-row class="pa-0">
                        <v-col cols="6" class="pa-0" align="right">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn v-on="on" icon @click="meGusta({uid: i.uid, index})" :color="i.mg ? 'red' : 'secondary'"><v-icon>fas fa-heart</v-icon></v-btn>
                            </template>
                            <span>{{$t('Inicio.Favorito')}}</span>
                          </v-tooltip>
                        </v-col>
                        <v-col cols="6" class="pa-0">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn v-on="on" icon color="black" @click="verProducto(i.uid)"><v-icon>fas fa-shopping-cart</v-icon></v-btn>
                            </template>
                            <span>{{$t('Inicio.VerProducto')}}</span>
                          </v-tooltip>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </template>
        </v-data-iterator>
        <v-pagination v-model="pagina" :length="cantidadPaginas"  style="outline-color:#484848!important;" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: 'Disenadores',
  mounted () {
    firebase.firestore().collection('productos').where('categoria', '==', 'disenador').where('aprobado', '==', true).limit(this.itemsPorPagina + 1).get().then(info => {
      this.ultimoDoc = info.docs[info.docs.length - 1]
      var cont = info.docs.length
      for (let i = 0; i < info.docs.length; i++) {
        var preProducto = info.docs[i].data()
        preProducto.artistaNombre = preProducto.artista.nombre
        this.productos.push(preProducto)
        this.categoriasSub.push(preProducto.subcategoria)
        this.paisesProducto.push(preProducto.artista.pais)
        this.paisesGet = this.getPaises
        cont = cont - 1
        if (cont === 0) {
          for (let index = 0; index < this.productos.length; index++) {
            if (this.getUsuario.favoritos.includes(this.productos[index].uid)) {
              this.productos[index].mg = true
            }
          }
        }
      }
    })
    this.subcategorias.push({
      titulo: this.$i18n.t('Categoria.Todos'),
      id: 'Todo'
    })
    firebase.firestore().collection('utilidades').doc('categorias').get().then(info => {
      for (let n = 0; n < this.categoriasSub.length; n++) {
        for (let i = 0; i < info.data().disenadores.length; i++) {
          if (this.categoriasSub[n] === info.data().disenadores[i]) {
            this.subcategorias.push({
              titulo: this.$i18n.t('Categoria.' + info.data().disenadores[i]),
              id: info.data().disenadores[i]
            })
          } else {}
        }
      }
      // for (let i = 0; i < info.data().disenadores.length; i++) {
      //   this.subcategorias.push({
      //     titulo: this.$i18n.t('Categoria.' + info.data().disenadores[i]),
      //     id: info.data().disenadores[i]
      //   })
      // }
      for (let n = 0; n < this.paisesProducto.length; n++) {
        for (let i = 0; i < this.paisesGet.length; i++) {
          if (this.paisesProducto[n] === this.paisesGet[i].name) {
            this.paisesOrigen.push(this.paisesGet[i].name)
          } else {}
        }
      }
    })
    this.productosFiltrados = this.productos
    if (this.productos < this.itemsPorPagina) {
      this.cantidadPaginas = this.cantidadPaginas - 1
    }
  },
  data () {
    return {
      pagina: 1,
      cantidadPaginas: 2,
      itemsPorPagina: 12,
      ultimoDoc: null,
      productos: [],
      categoriasSub: [],
      paisesProducto: [],
      productosFiltrados: [],
      paisDeOrigen: '',
      buscar: '',
      precio: '',
      subcategorias: [],
      precios: [
        {
          titulo: this.$i18n.t('Busqueda.PrecioMayor'),
          id: 'precioMayor'
        },
        {
          titulo: this.$i18n.t('Busqueda.PrecioMenor'),
          id: 'precioMenor'
        }
      ],
      orientaciones: [],
      orientacion: '',
      formatos: [],
      paisesGet: [],
      paisesOrigen: [],
      formato: '',
      subcategoria: ''
    }
  },
  watch: {
    pagina (nuevo, viejo) {
      if (nuevo >= this.cantidadPaginas) {
        firebase.firestore().collection('productos').where('categoria', '==', 'disenador').where('aprobado', '==', true).startAfter(this.ultimoDoc).limit(this.itemsPorPagina + 1).get().then(info => {
          if (info.docs.length > 0) {
            this.cantidadPaginas = this.cantidadPaginas + 1
          }
          this.ultimoDoc = info.docs[info.docs.length - 1]
          var cont = info.docs.length
          for (let i = 0; i < info.docs.length; i++) {
            var preProducto = info.docs[i].data()
            preProducto.artistaNombre = preProducto.artista.nombre
            // console.log(preProducto)
            this.productos.push(preProducto)
            cont = cont - 1
            if (cont === 0) {
              for (let index = 0; index < this.productos.length; index++) {
                if (this.getUsuario.favoritos.includes(this.productos[index].uid)) {
                  this.productos[index].mg = true
                }
              }
            }
          }
        })
      }
    },
    getIdioma: function (n, v) {
      if (n) {
        this.precios = [
          {
            titulo: this.$i18n.t('Busqueda.PrecioMayor'),
            id: 'precioMayor'
          },
          {
            titulo: this.$i18n.t('Busqueda.PrecioMenor'),
            id: 'precioMenor'
          }
        ]
        let subcat = []
        for (let i = 0; i < this.subcategorias.length; i++) {
          subcat.push({
            titulo: this.$i18n.t(`Categoria.${this.subcategorias[i].id}`),
            id: this.subcategorias[i].id
          })
          if (i === (this.subcategorias.length - 1)) {
            this.subcategorias = subcat
          }
        }
      }
    },
    subcategoria: function (n, v) {
      if (n === 'Todo') {
        this.productosFiltrados = this.productos
      } else {
        this.productosFiltrados = []
        for (let i = 0; i < this.productos.length; i++) {
          if (this.productos[i].subcategoria === n) {
            this.productosFiltrados.push(this.productos[i])
          }
        }
      }
    },
    paisDeOrigen: function (n, v) {
      var info = this.productos
      this.productosFiltrados = []
      for (let i = 0; i < info.length; i++) {
        if (info[i].artista.pais === n) {
          this.productosFiltrados.push(info[i])
        }
      }
    },
    precio: function (n, v) {
      if (n === 'precioMayor') {
        this.productosFiltrados.sort(function (a, b) {
          return Number(b.precioFisico || b.precioDigital) - Number(a.precioFisico || a.precioDigital)
        })
      } else {
        this.productosFiltrados.sort(function (a, b) {
          return Number(a.precioFisico || a.precioDigital) - Number(b.precioFisico || a.precioDigital)
        })
      }
    }
  },
  computed: {
    ...mapGetters(['getUsuario', 'getMoneda', 'getDolar', 'getPaises', 'getIdioma'])
  },
  methods: {
    ...mapMutations(['setAlerta', 'setTextoAlerta']),
    onIntersect (entries, observer, isIntersecting) {
      if (entries[0].isIntersecting) {
        this.itemsPorPagina = this.itemsPorPagina + 12
      }
    },
    verProducto (uid) {
      this.$router.push('/p/' + uid)
    },
    meGusta (info) {
      if (this.productosFiltrados[info.index].mg) {
        this.productosFiltrados[info.index].mg = false
        firebase.firestore().collection('usuarios').doc(this.getUsuario.uid).update({
          favoritos: firebase.firestore.FieldValue.arrayRemove(info.uid)
        })
        firebase.firestore().collection('productos').doc(info.uid).update({
          meGusta: firebase.firestore.FieldValue.increment(-1)
        })
        this.setAlerta()
        this.setTextoAlerta('Alerta.NoMeGusta')
      } else {
        if (this.getUsuario.rol !== 'invitado') {
          this.productosFiltrados[info.index].mg = true
          firebase.firestore().collection('usuarios').doc(this.getUsuario.uid).update({
            favoritos: firebase.firestore.FieldValue.arrayUnion(info.uid)
          })
          firebase.firestore().collection('productos').doc(info.uid).update({
            meGusta: firebase.firestore.FieldValue.increment(1)
          })
          this.setAlerta()
          this.setTextoAlerta('Alerta.MeGusta')
        } else {
          this.setAlerta()
          this.setTextoAlerta('Alerta.SinMeGusta')
        }
      }
    }
  }
}
</script>

<style>
.raya {
  border: 2px solid #000000;
  border-radius: 0!important;
}
.subcat {
  margin: 6px!important;
  font-size: 16px!important;
  font-family: 'Be Vietnam', sans-serif!important;
}
.fondoBuscar {
  background:rgb(38, 166, 154)!important;
}
.fondoBuscar .v-input__slot {
  background:rgb(38, 166, 154)!important;
  color: black!important;
}
.fondoBuscar .v-input__slot .v-label, .fondoBuscar .v-input__slot input {
  color: black!important;
}
.fondoBuscar .v-input__icon .v-icon {
  color: #F8F100!important;
  caret-color: #F8F100!important;
}
.v-pagination li {
  outline-color:#484848!important;
}
</style>
